export default __webpack_public_path__ + "static/media/seasonpass.0de0b0cc.webp";